module.exports = __webpack_public_path__ + "img/rotate-anticlockwise.c43fe1f6.svg";